import BigNumber from 'bignumber.js';

import { DlVault } from 'types/contracts';

export interface GetUserInfoInput {
  dlVaultContract: DlVault;
  accountAddress: string;
}

export type GetUserInfoOutput = {
  balance: string;
  stake: string;
  dailyReward: string;
  totalRewards: string;
  startTime: string;
  endTime: string;
  lastClaimTime: string;
  directReferrals: string;
  totalStaticReward: string;
  claimedStaticReward: string;
};

const getUserInfo = async ({
  dlVaultContract,
  accountAddress,
}: GetUserInfoInput): Promise<GetUserInfoOutput> => {
  const res = await dlVaultContract.methods
    .getUserInfo(accountAddress)
    .call();

  return {
    balance: res.balance || '0',
    stake: res.stake || '0',
    dailyReward: res.dailyReward || '0',
    totalRewards: res.totalRewards || '0',
    startTime: res.startTime || '0',
    endTime: res.endTime || '0',
    lastClaimTime: res.lastClaimTime || '0',
    directReferrals: res.directReferrals || '0',
    totalStaticReward: res.totalStaticReward || '0',
    claimedStaticReward: res.claimedStaticReward || '0',
  };
};

export default getUserInfo; 